module.exports = __webpack_public_path__ + "static/media/14.a6361aec.jpeg";